import { render, staticRenderFns } from "./TravelersSection.vue?vue&type=template&id=8f464658&scoped=true"
import script from "./TravelersSection.vue?vue&type=script&lang=js"
export * from "./TravelersSection.vue?vue&type=script&lang=js"
import style0 from "./TravelersSection.vue?vue&type=style&index=0&id=8f464658&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f464658",
  null
  
)

export default component.exports